import React from "react";
import { Button, Container } from "react-bootstrap";
import CreateBrand from "../components/modals/CreateBrand";
import CreateType from "../components/modals/CreateType";
import CreateDetail from "../components/modals/CreateDetail";
import CreateSubType from "../components/modals/CreateSubType";
import CreateForklift from "../components/modals/CreateForklift";

const Admin = () => {
    const [brandVisible, setBrandVisible] = React.useState(false);
    const [typeVisible, setTypeVisible] = React.useState(false);
    const [detailVisible, setDetailVisible] = React.useState(false);
    const [subTypeVisible, setSubTypeVisible] = React.useState(false);
    const [forkliftVisible, setForkliftVisible] = React.useState(false); 

    return (
        <Container className="d-flex flex-column">
            <Button 
                variant={"primary"} 
                className="mt-2"
                onClick={() => setTypeVisible(true)}
                >
                    Добавить тип
            </Button>
            <Button 
                variant={"secondary"} 
                className="mt-2"
                onClick={() => setSubTypeVisible(true)}
                >
                    Добавить подтип
            </Button>
            <Button 
                variant={"success"} 
                className="mt-2"
                onClick={() => setBrandVisible(true)}
                >
                    Добавить бренд
            </Button>
            <Button 
                variant={"warning"} 
                className="mt-2"
                onClick={() => setDetailVisible(true)}
                >
                    Добавить деталь
            </Button>
            <Button 
                variant={"danger"} 
                className="mt-2"
                onClick={() => setForkliftVisible(true)}
                >
                    Добавить погрузчик
            </Button>

            {/* Модальные окна */}
            <CreateBrand show={brandVisible} onHide={() => setBrandVisible(false)} />
            <CreateType show={typeVisible} onHide={() => setTypeVisible(false)} />
            <CreateDetail show={detailVisible} onHide={() => setDetailVisible(false)} />
            <CreateSubType show={subTypeVisible} onHide={() => setSubTypeVisible(false)} />
            <CreateForklift show={forkliftVisible} onHide={() => setForkliftVisible(false)} />
        </Container>
    );
};

export default Admin;